import {useTemplate} from 'Event/TemplateProvider'
import {useSaveTemplate} from 'Event/TemplateUpdateProvider'
import TextField from 'lib/ui/TextField'
import {useConfig} from 'organization/Event/Configurable'
import Config from 'organization/Event/Configurable/Config'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import React from 'react'
import StyleFields from 'Event/auth/TextField/StyleFields'
import Title from 'lib/ui/ConfigPanel/Title'
import {useAttendeeVariables} from 'Event'
import {useAddTranslation} from 'Event/LanguageProvider'
import {replaceAtPath} from 'lib/JsonUpdateProvider'

export default function FirstNameFieldConfig() {
  const saveTemplate = useSaveTemplate()
  const {signUp, login} = useTemplate()
  const v = useAttendeeVariables()
  const addTranslation = useAddTranslation()

  const save = (data: any) => {
    const label = replaceAtPath(
      data,
      'signUp.firstNameLabel',
      '{{sign_up_first_name_label}}',
    )
    saveTemplate({
      ...data,
      localization: addTranslation({
        sign_up_first_name_label: label ?? '',
      }),
    })
  }

  const {
    form: {register},
  } = useConfig()

  return (
    <Config title="First Name Field" onSave={save}>
      <SettingsPanel>
        <Title>First Name</Title>
        <TextField
          name="signUp.firstNameLabel"
          defaultValue={v(signUp.firstNameLabel)}
          label="Label"
          inputProps={{
            'aria-label': 'first name label',
            ref: register,
          }}
        />
      </SettingsPanel>
      <StylingPanel>
        <StyleFields templateKey="login.input" values={login.input} />
      </StylingPanel>
    </Config>
  )
}
